import { Avatar, Chip } from "@mui/material";
import styled from "styled-components";
import { tokens } from "@/tokens";

export const StyledChip = styled(Chip)(({ role }) => ({
  color: "#1D1D1D",
  borderColor: "transparent",
  height: "36px",
  padding: "6px",
  borderRadius: "32px",
  backgroundColor: role === "ADMIN" ? "#5263FF26" : "#9747FF26",
  fontWeight: tokens.fontWeight.semibold,
  fontSize: tokens.fontSize.xl,
  gap: "5px",
  "& .MuiChip-label": {
    paddingInline: "5px",
  },
}));

export const StyledAvatar = styled(Avatar)({
  width: "18px !important",
  height: "18px !important",
  margin: 0,
  "& img": {
    objectFit: "fill",
  },
});
